import FJActionConstant from "../../constant/FJActionConstant";
import FJViewConstant from "../../constant/FJViewConstant";

const initState = {
  volume: 0.5,
  speed: 1,
  zoomScale: 100,
  mediaStatus: FJViewConstant.MEDIA_STATUS_SUCCESS,
	mediaName: ''
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.SET_VIDEO_VOLUME:
      return {
        ...state,
        volume: action.volume,
      };
    case FJActionConstant.SET_VIDEO_SPEED:
      return {
        ...state,
        speed: action.speed,
      }
    case FJActionConstant.SET_VIDEO_ZOOM_SCALE:
      return {
        ...state,
        zoomScale: action.zoomScale
      };
    case FJActionConstant.SET_VIDEO_MEDIA_STATUS:
      return {
        ...state,
        mediaStatus: action.mediaStatus,
      }
		case FJActionConstant.SET_VIDEO_MEDIA_NAME:
			return {
				...state,
				mediaName: action.mediaName
			}
    default:
      return state;
  }
}
